const maxIdleTime = 1000 * 60 * 60 * 2; // 2 hours

export function getTimeAway(lastVisit: number): { minutes: number, hours: number } {
  let timeDiff = Date.now() - lastVisit;
  if(timeDiff >= maxIdleTime) return { hours : 2, minutes: 0 }

  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  timeDiff -= hours * (1000 * 60 * 60)
  const minutes = Math.floor(timeDiff / (1000 * 60));

  return { hours, minutes };
}
